export const ROUTES = {
	// Auth
	LOGIN: "/login",

	// Core
	HOME: "/",
	MAP: "/map",
	SEARCH: "/search/:query?",
	METHODOLOGIES: "/methodologies",

	// Features
	CURIOSITY: "/curiosity",
	CURIOSITY_CONVERSATION: "/curiosity/:conversationId",
	HOW_TO: "/how-to",

	// Galileo
	GALILEO: "/galileo",
	GALILEO_BENCHMARKS: "/galileo/benchmarks",
	GALILEO_SEARCH: "/galileo/search",

	// Abacus
	ABACUS: "/abacus/",
	ABACUS_COST: "/abacus-cost/",
	ABACUS_COST_INPUT: "/abacus-cost/input",
	ABACUS_COST_BENCHMARK: "/abacus-cost/benchmark",
	ABACUS_COST_SEARCH: "/abacus-cost/search",
	ABACUS_DURATION: "/abacus-duration/",
	ABACUS_DURATION_INPUT: "/abacus-duration/input",
	ABACUS_DURATION_BENCHMARK: "/abacus-duration/benchmark",
	ABACUS_DURATION_SEARCH: "/abacus-duration/search",
	ABACUS_DURATION_PRODUCTIVITY: "/abacus-duration/productivity",
	ABACUS_DURATION_PRODUCTIVITY_DOC: "/abacus-duration/productivity/:documentId",

	// Admin
	ADMIN: "/admin",
	ADMIN_USERS: "/admin/users",
	ADMIN_METHODOLOGIES: "/admin/methodologies",
	ADMIN_HOW_TO: "/admin/how-to",
	ADMIN_NOTES: "/admin/notes",

	// Development
	PLAYGROUND: "/playground",

	// Files
	FILE_VIEWER: "/files/:containername/*",

	// Error
	SERVER_DOWN: "/server-down",
} as const;

export type AppRoutePath = (typeof ROUTES)[keyof typeof ROUTES];
